module.exports = __webpack_public_path__ + "static/media/sub-title.5eb1213e.png";